export { default } from './ChessKnight'
